import React, { useState, useEffect } from 'react';
import apiService from '../services/api';
import './Universities.css';

const Universities = () => {
  const [universities, setUniversities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchUniversities();
  }, []);

  const fetchUniversities = async () => {
    try {
      setLoading(true);
      const response = await apiService.getUniversities();
      setUniversities(response);
    } catch (err) {
      setError('Failed to load universities');
      console.error('Error fetching universities:', err);
    } finally {
      setLoading(false);
    }
  };

  const groupedUniversities = universities.reduce((acc, university) => {
    const country = university.country;
    if (!acc[country]) {
      acc[country] = [];
    }
    acc[country].push(university);
    return acc;
  }, {});

  if (loading) {
    return (
      <div className='universities'>
        <div className='universities-container'>
          <div className='responsive-loading'>
            <div className='responsive-spinner' />
            <p>Loading Features...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='universities'>
        <div className='universities-container'>
          <div className='error-message'>
            <p>{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='universities'>
      <div className='universities-container'>
        <div className='universities-header'>
          <h1>Our Partner Universities</h1>
          <p>Discover world-class institutions across the globe</p>
        </div>

        <div className='universities-content'>
          {Object.entries(groupedUniversities).map(([country, countryUniversities]) => (
            <div key={country} className='country-section'>
              <div className='country-header'>
                <h2>{country}</h2>
                <span className='university-count'>{countryUniversities.length} Universities</span>
              </div>

              <div className='universities-grid'>
                {countryUniversities.map((university) => (
                  <div key={university.id} className='university-card'>
                    <div className='university-logo'>
                      {university.logo ? (
                        <img
                          src={`${process.env.REACT_APP_API_URL_WITH_OUT_API}${university.logo}`}
                          alt={`${university.name} logo`}
                          crossOrigin='anonymous'
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                          }}
                        />
                      ) : null}
                      <div
                        className='logo-placeholder'
                        style={{ display: university.logo ? 'none' : 'flex' }}
                      >
                        <span>{university.name.charAt(0)}</span>
                      </div>
                    </div>

                    <div className='university-info'>
                      <h3>{university.name}</h3>
                      <p className='university-location'>
                        {university.city}, {university.country}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Universities;
